"use client";
import { COLLECTION_NAMES } from "@/constants/collections";
import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t, i18n } = useTranslation();
  const imagePathforDesktop =
    i18n.language === "hi"
      ? "/images/home/herobannerdesktopNew.webp"
      : "/images/home/herobannerdesktopNew.webp";

  const imagePathforMobile =
    i18n.language === "hi"
      ? "/images/home/herobannerNew.webp"
      : "/images/home/herobannerNew.webp";

  return (
    <div className="px-2 sm:px-4 py-4 sm:py-6 md:py-2 bg-white">
      <Link href={`/collections/${decodeURIComponent(COLLECTION_NAMES)}`}>
        <div className="relative w-full rounded-xl overflow-hidden">
          <Image
            src={imagePathforDesktop}
            alt="Hand holding Ryze gum"
            width={1440}
            height={600}
            priority
            fetchPriority="high"
            sizes="(max-width: 640px) 0px, 100vw"
            className="hidden md:block object-cover w-full h-auto rounded-xl"
          />
          <Image
            src={imagePathforMobile}
            alt="Hand holding Ryze gum mobile"
            width={640}
            height={800}
            priority
            fetchPriority="high"
            sizes="(max-width: 640px) 100vw, 0px"
            className="object-cover w-full h-auto rounded-xl md:hidden"
          />
        </div>
      </Link>
    </div>
  );
}
